export function GetMockUserRead() {
  return {
    employeeId: "1897336",
    name: "Trevor Hicks",
  };
}
